import * as angular from "angular";
import {DocumentSettings} from "../models/document-settings.model";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class TravelTimeRuleAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  getRulesError() {
    const message = {
      body: 'TRAVEL_TIME_RULE_GET_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE //
  createRuleSuccess() {
    const message = {
      body: 'TRAVEL_TIME_RULE_CREATE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  createRuleError() {
    const message = {
      body: 'TRAVEL_TIME_RULE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateRuleSuccess() {
    const message = {
      body: 'TRAVEL_TIME_RULE_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateRuleError() {
    const message = {
      body: 'TRAVEL_TIME_RULE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteRuleSuccess() {
    const message = {
      body: 'TRAVEL_TIME_RULE_DELETE_SUCCESS'
    };

    return this.bringozToastService.success(message)
  }

  deleteRuleError() {
    const message = {
      body: 'X_DOCUMENT_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .service('travelTimeRuleAlerts', TravelTimeRuleAlerts);
